import { each, equals2, go, mapL, reduce } from "fxjs/es";
import { $$parsePathDateL } from "fxsvg";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
import { PROCESSING_TASK } from "./const.js";
export const startEditCuttingLinePath = (self) => {
  self._checkNoProcessingTask();
  const outer_cutting_line_display_path_el =
    self._getOuterCuttingLineDisplayPathElThrowable();
  const path_editor_layer_el = self._getPathEditorLayerElThrowable();
  const path_editor_point_container_el =
    self._getPathEditorPointContainerElThrowable();
  const path_editor_line_container_el =
    self._getPathEditorLineContainerElThrowable();
  const view_port = self._getViewPortThrowable();
  const view_box = self._getViewBoxThrowable();
  const getPathElCTM = () => {
    const ctm = outer_cutting_line_display_path_el.getCTM();
    if (ctm == null) {
      throw new Error(`재단선 패스 엘리먼트의 CTM 을 구할 수 없습니다.`);
    }
    return ctm;
  };
  const getPathEditorLayerElCTM = () => {
    const ctm = path_editor_layer_el.getCTM();
    if (ctm == null) {
      throw new Error(`path_editor_layer 엘리먼트의 CTM 을 구할 수 없습니다.`);
    }
    return ctm;
  };
  const path_editor_point_size_controller =
    new PathEditorNS.ControllerNS.PointSizeController({
      svg_el: self._svg_el,
      outer_size: 20,
      inner_size: 8,
      view_port,
      view_box,
      getCTM: getPathEditorLayerElCTM,
    });
  self._path_editor_list = go(
    self.getOuterCuttingLinePathData(),
    $$parsePathDateL,
    mapL(({ command, parameters }) => {
      if (equals2(command)("M")) {
        const target_point = new PathEditorNS.ModelNS.Point({
          x: parameters[0],
          y: parameters[1],
        });
        const command_m = new PathEditorNS.ModelNS.CommandM({
          svg_el: self._svg_el,
          target_point,
        });
        const command_m_controller =
          new PathEditorNS.ControllerNS.CommandMController({
            command_m,
            svg_el: self._svg_el,
            getPathElCTM,
            getPathEditorLayerElCTM,
          });
        const command_m_view = new PathEditorNS.ViewNS.CommandMView({
          command_m_controller,
          target_point_view: new PathEditorNS.ViewNS.TargetPointView({
            document: self._document,
            point_size_controller: path_editor_point_size_controller,
          }),
        });
        return {
          model: command_m,
          view: command_m_view,
        };
      }
      if (equals2(command)("L")) {
        const target_point = new PathEditorNS.ModelNS.Point({
          x: parameters[0],
          y: parameters[1],
        });
        const command_l = new PathEditorNS.ModelNS.CommandL({
          svg_el: self._svg_el,
          target_point,
        });
        const command_l_controller =
          new PathEditorNS.ControllerNS.CommandLController({
            command_l,
            svg_el: self._svg_el,
            getPathElCTM,
            getPathEditorLayerElCTM,
          });
        const command_l_view = new PathEditorNS.ViewNS.CommandLView({
          command_l_controller,
          target_point_view: new PathEditorNS.ViewNS.TargetPointView({
            document: self._document,
            point_size_controller: path_editor_point_size_controller,
          }),
        });
        return {
          model: command_l,
          view: command_l_view,
        };
      }
      if (equals2(command)("C")) {
        const control_point1 = new PathEditorNS.ModelNS.Point({
          x: parameters[0][0],
          y: parameters[0][1],
        });
        const control_point2 = new PathEditorNS.ModelNS.Point({
          x: parameters[1][0],
          y: parameters[1][1],
        });
        const target_point = new PathEditorNS.ModelNS.Point({
          x: parameters[2][0],
          y: parameters[2][1],
        });
        const command_c = new PathEditorNS.ModelNS.CommandC({
          svg_el: self._svg_el,
          control_point1,
          control_point2,
          target_point,
        });
        const command_c_controller =
          new PathEditorNS.ControllerNS.CommandCController({
            command_c,
            svg_el: self._svg_el,
            getPathElCTM,
            getPathEditorLayerElCTM,
          });
        const command_c_view = new PathEditorNS.ViewNS.CommandCView({
          command_c_controller,
          control_point1_view: new PathEditorNS.ViewNS.ControlPointView({
            document: self._document,
            point_size_controller: path_editor_point_size_controller,
          }),
          control_point2_view: new PathEditorNS.ViewNS.ControlPointView({
            document: self._document,
            point_size_controller: path_editor_point_size_controller,
          }),
          target_point_view: new PathEditorNS.ViewNS.TargetPointView({
            document: self._document,
            point_size_controller: path_editor_point_size_controller,
          }),
          control_line1_view: new PathEditorNS.ViewNS.LineView({
            document: self._document,
          }),
          control_line2_view: new PathEditorNS.ViewNS.LineView({
            document: self._document,
          }),
        });
        return {
          model: command_c,
          view: command_c_view,
        };
      }
      if (equals2(command)("Q")) {
        const control_point = new PathEditorNS.ModelNS.Point({
          x: parameters[0][0],
          y: parameters[0][1],
        });
        const target_point = new PathEditorNS.ModelNS.Point({
          x: parameters[1][0],
          y: parameters[1][1],
        });
        const command_q = new PathEditorNS.ModelNS.CommandQ({
          svg_el: self._svg_el,
          control_point,
          target_point,
        });
        const command_q_controller =
          new PathEditorNS.ControllerNS.CommandQController({
            command_q,
            svg_el: self._svg_el,
            getPathElCTM,
            getPathEditorLayerElCTM,
          });
        const command_q_view = new PathEditorNS.ViewNS.CommandQView({
          command_q_controller,
          control_point_view: new PathEditorNS.ViewNS.ControlPointView({
            document: self._document,
            point_size_controller: path_editor_point_size_controller,
          }),
          target_point_view: new PathEditorNS.ViewNS.TargetPointView({
            document: self._document,
            point_size_controller: path_editor_point_size_controller,
          }),
          control_line1_view: new PathEditorNS.ViewNS.LineView({
            document: self._document,
          }),
          control_line2_view: new PathEditorNS.ViewNS.LineView({
            document: self._document,
          }),
        });
        return {
          model: command_q,
          view: command_q_view,
        };
      }
      if (equals2(command)("A")) {
        const target_point = new PathEditorNS.ModelNS.Point({
          x: parameters[5],
          y: parameters[6],
        });
        const command_a = new PathEditorNS.ModelNS.CommandA({
          svg_el: self._svg_el,
          target_point,
          rx: parameters[0],
          ry: parameters[1],
          x_axis_rotation: parameters[2],
          large_arc_flag: parameters[3],
          sweep_flag: parameters[4],
        });
        const command_a_controller =
          new PathEditorNS.ControllerNS.CommandAController({
            command_a,
            svg_el: self._svg_el,
            getPathElCTM,
            getPathEditorLayerElCTM,
          });
        const command_a_view = new PathEditorNS.ViewNS.CommandAView({
          command_a_controller,
          target_point_view: new PathEditorNS.ViewNS.TargetPointView({
            document: self._document,
            point_size_controller: path_editor_point_size_controller,
          }),
        });
        return {
          model: command_a,
          view: command_a_view,
        };
      }
      if (equals2(command)("Z")) {
        const command_z = new PathEditorNS.ModelNS.CommandZ();
        const command_z_view = new PathEditorNS.ViewNS.CommandZView({
          placeholder_g_el: self._document.createElementNS(
            CommonNS.ConstNS.SVG_NAMESPACE,
            "g"
          ),
        });
        return {
          model: command_z,
          view: command_z_view,
        };
      }
      throw new Error(`유효하지 않는 path command 입니다. (${command})`);
    }),
    (iter) =>
      reduce(
        (acc, cur) => {
          if (acc.prev != null) {
            cur.model.setPrevCommand(acc.prev.model);
          }
          acc.list.push(cur);
          acc.prev = cur;
          return acc;
        },
        {
          list: [],
          prev: null,
        },
        iter
      ),
    ({ list }) => list,
    each(({ view }) =>
      view.appendTo({
        point_container_el: path_editor_point_container_el,
        line_container_el: path_editor_line_container_el,
      })
    )
  );
  self._path_editor_point_size_controller = path_editor_point_size_controller;
  self._processing_task = PROCESSING_TASK.PATH_EDITING;
};
